import React from 'react';
import Navbar from '../../../components/Navbar';
import Footer from '../../../components/Footer';
import Copyright from '../../../components/Copyright';
import Optometry from './Optometry';

export default function Blog() {
  return (
    <>
        <Navbar />
        <Optometry />
        <Footer />
        <Copyright />
    </>
  )
}